import * as React from 'react'
import { IMap, IVehicleObj } from '../../../types'
import { IProviderProductObject } from '../../../types/provider-product'
import { Link } from 'react-router-dom'

interface IProductsProps {
  vehicle: IVehicleObj
  providerProduct: IMap<IProviderProductObject>
}

const Products = (props: IProductsProps) => {
  return (
    <div className='col-12'>
      <div className='ml3'>
        <p className='bold font-dark-grey pt2'>Products</p>
        {productsInfo(props.vehicle.products, props.providerProduct)}
        <div className='h6 bold font-dark-grey cursor--pointer mt2'>
          <Link to={`/vehicles/edit/${props.vehicle.id}/products`}>+ Add Products</Link>
        </div>
      </div>
    </div>
  )
}

function productsInfo(vehicleProducts: IProviderProductObject[], providerProducts: IMap<IProviderProductObject>) {
  const sortedProducts = vehicleProducts.map(it => {
    const product = providerProducts[it.id]
    if (!product) {
      return null
    }
    return (
      <div className='border-light-grey4 rounded px1 mr1 h6 font-blue-grey bold' key={product.id}>
        {product.name}
      </div>
    )
  })
  return <div className='flex flex-wrap items-center pt1 pb1'>{sortedProducts}</div>
}

export default Products



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/Products.tsx